import { I18n } from '@ngx-translate/i18n-polyfill';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService } from '../../service/toast.service';

@Component({
  selector: 'app-save-toast',
  templateUrl: './save-toast.component.html',
  styleUrls: ['./save-toast.component.less']
})
export class SaveToastComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  show: boolean;
  message : string;
  count : number;
  type : string;
  constructor(
    private readonly _toastService: ToastService,
    private readonly i18n: I18n
  ) { this.show = false;
      this.message = this.i18n({
        id: "save",
        value: "Sauvegarde",
        description: "Sauvegarde",
        meaning: "save-toast"
      }); 
      this.count = 0;
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {

    this.subscription = this._toastService.openToastObs.subscribe((data) => {
      console.log("data modal", data);
      if(data.message)
        this.message = data.message;
      else
        this.message =  this.i18n({
          id: "save",
          value: "Sauvegarde",
          description: "Sauvegarde",
          meaning: "save-toast"
        });

      if (data.type)
        this.type = data.type;
      else
        this.type = 'standard';

      if (data.open === undefined) {
        this.show = true;
        $('.toast-content').css('opacity', 1);
        setTimeout(() => {
          $('.toast-content').css('opacity', 0);
          setTimeout(() => {
            this.show = false;
          }, 300)
        }, 1000)
      }
      else {
        if (data.open === true) {
          this.count++;
          this.show = true;
          $('.toast-content').css('opacity', 1);
        } else if (data.open === false) {
          this.count--;
          if (this.count === 0){
          setTimeout(() => {
            $('.toast-content').css('opacity', 0);
            setTimeout(() => {
              this.show = false;
            }, 300)
          }, 1000)}
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/element/save-toast/save-toast.component.ts